var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftArrow = function SvgLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#858995",
    fillRule: "evenodd",
    d: "M2.25 9c0-.31.252-.562.563-.562h12.375a.562.562 0 1 1 0 1.124H2.813A.563.563 0 0 1 2.25 9",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#858995",
    fillRule: "evenodd",
    d: "M8.273 3.54c.22.22.22.576 0 .795L3.608 9l4.665 4.665a.562.562 0 1 1-.796.795L2.415 9.398a.563.563 0 0 1 0-.796L7.477 3.54c.22-.22.576-.22.796 0",
    clipRule: "evenodd"
  })));
};
export default SvgLeftArrow;